export default __webpack_public_path__ + "static/media/product17.4d21563e.png";